import { BaseModel } from '../../base.model';

/**
 * Request body for POST /api/emem/equipment (WI 32008): duplicate an existing
 * equipment master (bEMEM) into a new record. The source row is cloned
 * server-side; the identifying fields below are supplied by the user so the new
 * unit does not share identifying values, and per-unit fields (meters, dispatch,
 * financial, dates, attachments) are cleared server-side. Descriptive fields fall
 * back to the source when left blank.
 */
export class DuplicateEquipmentResourceDto extends BaseModel {
  /** KeyId of the equipment record being duplicated (the clone source). */
  public SourceKeyId: number;

  /** New equipment code / identifier (bEMEM.Equipment, the PK part). Required, max 10 chars. */
  public EquipmentName: string;

  /** New description. Falls back to the source when blank. Max 60 chars. */
  public EquipmentDescription: string;

  /** New VIN / serial. Not inherited from the source. Max 40 chars. */
  public EquipmentVinNumber: string;

  /** Category. Falls back to the source when blank. Max 10 chars. */
  public EquipmentCategory: string;

  /** Manufacturer. Falls back to the source when blank. Max 20 chars. */
  public EquipmentManufacturer: string;

  /** Model. Falls back to the source when blank. Max 20 chars. */
  public EquipmentModel: string;

  /** Model year. Falls back to the source when blank. Max 6 chars. */
  public EquipmentModelYear: string;

  /** Status (char(1)). Falls back to the source when blank. */
  public EquipmentStatus: string;
}
